import Sentry from "@similarweb/sentry-logger";

import { openDefaultHooksModal, openStateUnlockModal } from "app/services/ModalService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const openLockedFeatureHook = (uiRouterState: string | undefined, hookKey?: string): void => {
    if (uiRouterState) {
        try {
            const targetState = proNavigator.getState(uiRouterState);

            if (targetState) {
                openStateUnlockModal(targetState);
                return;
            }
        } catch (error) {
            Sentry.errorTracker({
                e: error,
                message: "openLockedFeatureHook: failed to resolve state for unlock modal",
                level: "error",
                params: {
                    extra: { uiRouterState },
                },
            });
        }
    }
    openDefaultHooksModal(hookKey);
};
